<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="icon icon-tabler icons-tabler-outline icon-tabler-menu-order"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 10h16" />
    <path d="M4 14h16" />
    <path d="M9 18l3 3l3 -3" />
    <path d="M9 6l3 -3l3 3" />
  </svg>
</template>

<script lang="ts" setup>
export type Props = {
  width?: string;
  height?: string;
};

withDefaults(defineProps<Props>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
